import { t } from "i18next";
export const userOptions = [
  { value: "All", label: t("All") },
  { value: "Self", label: t("_Self") },
  { value: "User1", label: "User1" },
  { value: "User2", label: "User2" },
];

export const enterpriseOptions = [
  { value: "All", label: t("All") },
  { value: "Enterprise1", label: "Enterprise1" },
  { value: "Enterprise2", label: "Enterprise2" },
];

export const categoryOptions = [
  { value: "Promotional", label: t("_Promotional") },
  { value: "OTP", label: t("_OTP") },
];
export const campaignNameOptions = [
  { value: "Campaign 1", label: "Campaign 1" },
  { value: "Campaign 2", label: "Campaign 2" },
];
export const directionOptions = [
  { value: "all", label: "All" },
  { value: "MT", label: "_MT" },
  { value: "MO", label: "_MO" },
];

export const emaildirectionOptions = [
  { value: "all", label: "All" },
  { value: "MT", label: "MT" },
];
export const smsEmailCategoryOptions = [
  { value: "All", label: "All" },
  { value: "Promotional", label: "_Promotional" },
  { value: "Transactional", label: "_Transactional" },
  { value: "Authentication", label: "_Authentication" },
];
export const interfaceOptions = [
  { value: "all", label: "All" },
  { value: "SMPP", label: "_SMPP" },
  { value: "API", label: "API" },
  { value: "WEB", label: "_Portal" },
  { value: "FTP", label: "_FTP" },
];
export const statusOptions = [
  { value: "all", label: "All" },
  { value: "Failed", label: "_Failed" },
  { value: "Delivered", label: "_Delivered" },
];
export const packageOptions = [
  { value: "Package1", label: "Package1" },
  { value: "Package2", label: "Package2" },
];
export const senderOptions = [
  { value: "All", label: t("All") },
  { value: "COMVIV1", label: "COMVIV1" },
  { value: "COMVIV2", label: "COMVIV2" },
  { value: "COMSMS", label: "COMSMS" },
];


export const channelOptions = [
  { value: "sms", label: "SMS" },
  { value: "wa", label: "WhatsApp" },
  { value: "voice", label: "Voice" },
  { value: "email", label: "Email" },
  { value: "rcs", label: "RCS" },
];
export const countryOptions = [
  { value: "India", label: "India" },
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
];

export const finalStatusOptions = [
  { value: "Submit failed", label: "Submit failed" },
  { value: "Delivered", label: "Delivered" },
  { value: "SMS EPUSH SUBMIT ERROR", label: "SMS EPUSH SUBMIT ERROR" },
];
export const providerOptions = [{ value: "Airtel", label: "Airtel" }];
export const bindOptions = [
  { value: "BIND1", label: "BIND1" },
  { value: "BIND2", label: "BIND2" },
];
export const detailedReportsData = [
  {
    user: "User1",
    id: "22HO89sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "15/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "SMPP",
    channel: "sms",
  },
  {
    user: "User1",
    id: "22HO99sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "SMPP",
    channel: "sms",
  },
  {
    user: "User1",
    id: "22HO90sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "API",
    channel: "wa",
  },
  {
    user: "User1",
    id: "22HO70sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Failed",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "API",
    channel: "sms",
  },
  {
    user: "User1",
    id: "22HO71sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Failed",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "United Arab Emirates",
    interface: "API",
    channel: "wa",
  },
  {
    user: "User1",
    id: "22HO91sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "API",
    channel: "wa",
  },
  {
    user: "User1",
    id: "22HO87sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "Afghanistan",
    interface: "API",
    channel: "Voice",
  },
  {
    user: "User1",
    id: "22HO86sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "14/12/2022, 10:00:00",
    price: "0.2",
    country: "Afghanistan",
    interface: "API",
    channel: "Voice",
  },
  {
    user: "User2",
    id: "22HO85sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "Portal",
    channel: "Voice",
  },
  {
    user: "User2",
    id: "22HO84sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "12/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "Portal",
    channel: "Voice",
  },
  {
    user: "User2",
    id: "22HO83sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "12/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "Portal",
    channel: "sms",
  },
  {
    user: "User2",
    id: "22HO82sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "12/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "Portal",
    channel: "sms",
  },
  {
    user: "User2",
    id: "22HO81sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "SMPP",
    channel: "sms",
  },
  {
    user: "User2",
    id: "22HO80sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    interface: "SMPP",
    channel: "sms",
  },
];

export const detailedReportsPAData = [
  {
    enterprise: "Enterprise1",
    id: "22HO80sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "15/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "SMPP",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO80sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "15/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "API",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO80sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "15/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "Portal",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO70sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "15/12/2022, 10:00:00",
    price: "0.2",
    country: "United Arab Emirates",
    channel: "Voice",
    interface: "Portal",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO81sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "Portal",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO81sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "SMPP",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO81sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "API",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO81sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "13/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "sms",
    interface: "API",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO82sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "12/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "wa",
    interface: "SMPP",
  },
  {
    enterprise: "Enterprise1",
    id: "22HO83sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Delivered",
    time: "12/12/2022, 10:00:00",
    price: "0.2",
    country: "United Arab Emirates",
    channel: "wa",
    interface: "API",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO84sd",
    direction: "MO",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Failed",
    time: "11/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "wa",
    interface: "Portal",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO85sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMSMS",
    status: "Failed",
    time: "11/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "Voice",
    interface: "SMPP",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO86sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMSMS",
    status: "Delivered",
    time: "10/12/2022, 10:00:00",
    price: "0.2",
    country: "India",
    channel: "Voice",
    interface: "Portal",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO87sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMSMS",
    status: "Failed",
    time: "10/12/2022, 10:00:00",
    price: "0.2",
    country: "Afghanistan",
    channel: "Voice",
    interface: "API",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO87sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV1",
    status: "Failed",
    time: "10/12/2022, 10:00:00",
    price: "0.2",
    country: "Afghanistan",
    channel: "Voice",
    interface: "API",
  },
  {
    enterprise: "Enterprise2",
    id: "22HO87sd",
    direction: "MT",
    type: "Promotional",
    msisdn: "450009475864",
    sender: "COMVIV2",
    status: "Delivered",
    time: "10/12/2022, 10:00:00",
    price: "0.2",
    country: "Afghanistan",
    channel: "Voice",
    interface: "API",
  },
];

export const summaryReportsPAData = [
  {
    date: "12/12/2022",
    username: "Enterprise1",
    channel: "wa",
    category: "Promotional",
    interface: "API",
    totalsent: "500",
    totalsuccess: "450",
    totalfailed: "50",
  },
  {
    date: "13/12/2022",
    username: "Enterprise1",
    channel: "wa",
    category: "Promotional",
    interface: "SMPP",
    totalsent: "550",
    totalsuccess: "400",
    totalfailed: "150",
  },
  {
    date: "14/12/2022",
    username: "Enterprise1",
    channel: "wa",
    category: "Promotional",
    interface: "Portal",
    totalsent: "550",
    totalsuccess: "275",
    totalfailed: "275",
  },
  {
    date: "14/12/2022",
    username: "Enterprise1",
    channel: "wa",
    category: "Promotional",
    interface: "Portal",
    totalsent: "550",
    totalsuccess: "275",
    totalfailed: "275",
  },
  {
    date: "14/12/2022",
    username: "Enterprise2",
    channel: "sms",
    category: "Promotional",
    interface: "SMPP",
    totalsent: "400",
    totalsuccess: "250",
    totalfailed: "150",
  },
  {
    date: "15/12/2022",
    username: "Enterprise2",
    channel: "sms",
    category: "Promotional",
    interface: "API",
    totalsent: "600",
    totalsuccess: "400",
    totalfailed: "200",
  },
  {
    date: "15/12/2022",
    username: "Enterprise1",
    channel: "sms",
    category: "Promotional",
    interface: "Portal",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
  {
    date: "15/12/2022",
    username: "Enterprise2",
    channel: "sms",
    category: "Promotional",
    interface: "API",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
  {
    date: "15/12/2022",
    username: "Enterprise1",
    channel: "Voice",
    category: "Promotional",
    interface: "SMPP",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
  {
    date: "15/12/2022",
    username: "Enterprise2",
    channel: "Voice",
    category: "Promotional",
    interface: "API",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
  {
    date: "15/12/2022",
    username: "Enterprise1",
    channel: "Voice",
    category: "Promotional",
    interface: "SMPP",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
  {
    date: "15/12/2022",
    username: "Enterprise2",
    channel: "Voice",
    category: "Promotional",
    interface: "Portal",
    totalsent: "650",
    totalsuccess: "550",
    totalfailed: "100",
  },
];
export const voiceDirectionOptions = [
  { value: "All", label: "All" },
  { value: "incoming", label: "_Incoming" },
  { value: "outgoing", label: "_Outgoing" },
];
export const voiceproductOptions = [
  { value: "VR", label: t("_Virtual_Receptionist") },
  { value: "Voice", label: t("_Voice_Blast") },
];

export const interfaceVoiceOptions = [
  { value: "all", label: "All" },
  { value: "API", label: "API" },
  { value: "Portal", label: "_Portal" },
];

export const audioSourceOptions = [
  { value: "TTS", label: "TTS" },
  { value: "File", label: "Audio File" },
];
export const finalStatusOptionsForVoice = [
  { value: "all", label: t("All") },
  { value: "success", label: t("_Success") },
  { value: "failure", label: t("_Failure") },
];
export const campaignCategoryOptionsForVoice = [
  { value: "PROMO", label: t("_Promotional") },
  { value: "TXN", label: t("_Transactional") },
];

export const interfaceWAOptions = [
  { value: "all", label: "All" },
  { value: "API", label: "API" },
  { value: "WEB", label: "WEB" },
];

export const interfaceEmailOptions = [
  { value: "all", label: "All" },
  { value: "API", label: "API" },
  { value: "WEB", label: "WEB" },
];

export const waDirectionOptions = [
  { value: "All", label: "All" },
  { value: "9", label: "Marketing" },
  { value: "10", label: "Utility" },
  { value: "11", label: "Authentication" },
  { value: "12", label: "Service" },
];

export const waStatusOptions = [
  { value: "All", label: "All" },
  { value: "111", label: "_Read" },
  { value: "12009", label: "_Submitted" },
  { value: "1", label: "_Submit_Failed" },
  { value: "2", label: "_Delivered" },
  { value: "11", label: "_Delivery_Failed" },
];

export const whatsAppVolumeResponse = {
  WHATSAPP: {
    Delivered: 100,
    Failed: 30,
    Success: 50,
    "Total Received": 10,
    "Total Sent": 20,
    Undelivered: 89,
    DndBlackList: 87,
    revenue: "1000",
  },
};

export const whatsAppCampaignResponse = {
  campaigns: {
    revenue: "10",
    totalCamp: "20",
    scheduled: "30",
    completed: "40",
    inProgress: "50",
    paused: "60",
    failed: "70",
  },
};

export const whatsAppCampaignMessageResponse = {
  campaignMessages: {
    totalSent: "10",
    delivered: "20",
    success: "30",
    failed: "40",
    dndBlacklist: "50",
    totalReceived: "60",
  },
};

export const whatsAppTopCampaigns = [
  { name: "demopack", value: 100 },
  { name: "onida package", value: 150.0 },
  { name: "package3", value: 133.0 },
  { name: "package4", value: 140.0 },
  { name: "package5", value: 130.0 },
];

export const whatsAppTemplates = [{ Text: 200 }, { Media: 300 }];

export const whatsAppRevenueData = [
  { Utility: 20 },
  { Authentication: 30 },
  { Marketing: 10 },
  { total: 60 },
];

export const whatsAppPerformanceResponse = {
  WHATSAPP: { submit_failed: 10, submit_success: 20 },
};

export const whatsAppTemplateTypes = {
  Marketing: 1,
  Utility: 2,
  Autentication: 1,
  Total: 4,
};

export const whatsAppTemplateScheduleType = {
  SPECIFICDAYS: 10,
  ONETIME: 5,
  RECURRING: 7,
};
